import { Database } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'

type FramerAddItemResult = {
  item: {
    itemId: string
    slug: string
  }
  message: string
}

type Props = {
  result: FramerAddItemResult | null | undefined
}

export function FramerAddItemCard({ result }: Props) {
  const t = useTranslation()

  if (!result) return null

  return (
    <div className="my-1.5 rounded-xl border border-border bg-card p-3">
      <div className="flex items-start gap-2.5">
        <div className="flex items-center justify-center size-7 rounded-md bg-primary/10 shrink-0">
          <Database className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-card-foreground">
            {t('agent.tools.framer.addItemTitle')}
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {result.message || t('agent.tools.framer.addItemMessage')}
          </p>
          <div className="mt-2 flex items-center gap-1.5 text-[11px] text-muted-foreground">
            <span className="font-medium">{t('agent.tools.framer.addItemIdLabel')}:</span>
            <code className="font-mono bg-muted px-1.5 py-0.5 rounded">
              {result.item.itemId}
            </code>
          </div>
          <p className="mt-2 text-[11px] text-muted-foreground italic">
            {t('agent.tools.framer.addItemHint')}
          </p>
        </div>
      </div>
    </div>
  )
}
